import TransactionsList from './TransactionsList';

export default TransactionsList;
